import { useDialogState } from './useDialogState';

const useToggleRemoveDialog = () => {
  const {
    open: showRemoveDialog,
    openDialog: openRemoveDialog,
    closeDialog: closeRemoveDialog
  } = useDialogState(false);

  return {
    showRemoveDialog,
    openRemoveDialog,
    closeRemoveDialog
  };
};

export default useToggleRemoveDialog;
